import React from 'react';
import E_commerceIcon from '../svg/ecommerce.svg';

const IconE_commerce = () => (
  <img src={E_commerceIcon} alt="E-Commerce Icon" width={64} height={64} />
);

export default IconE_commerce;
